module.exports = __webpack_public_path__ + "static/media/sidebar-bg.360afe5b.jpeg";